"use strict";
var RangeObservable_1 = require('./RangeObservable');
exports.range = RangeObservable_1.RangeObservable.create;
//# sourceMappingURL=range.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/observable/range.js
 ** module id = 465
 ** module chunks = 3
 **/